import {Modal} from 'bootstrap'

export default class ModalClass {


    main

    opts

    constructor(p){
        let opts = this.opts = {...{
                btn: this.btn,
                open: (e) => {},
                opened: (e) => {},
                close: (e) => { if(!CS.Subsheet.close()) e.stopPropagation() },
                closed: (e) => {},
                title: 'n/a',
                bsSize: 'lg',

            }, ...p}
        let m = $('<div>').addClass('modal fade')
            .attr('id', opts.id)
            .addClass(opts.modalClass)

        let md = $('<div>').addClass('modal-dialog modal-'+opts.bsSize)


        let mc = $('<div>').addClass('modal-content')


        let mh = $('<div>').addClass('modal-header hstack gap-2')

        let mt = $('<h5>').addClass('modal-title')
            .html(opts.title)

        let buttons = $('<div>').addClass('hstack gap-2')
        let attach = $('<div>').addClass('ms-auto hstack gap-2').attr('id', 'attach')

        let mb = $('<div>').addClass('modal-body p-2')
            .html(opts.body)

        let mf = $('<div>').addClass('modal-footer')
            .html(opts.footer)

        $(opts.btn).each((name, el) => {
            buttons.append(el)
        })

        m.append(md)
        md.append(mc)
        mc.append(mh,mb)
        mh.append(mt,attach,buttons)

        if(opts.footer) mc.append(mf)

        $(m).on('show.bs.modal',  (e) => { return opts.open(e)});
        $(m).on('shown.bs.modal',  (e) => { return opts.opened(e)});
        $(m).on('hide.bs.modal', (e) => { return opts.close(e) })
        $(m).on('hidden.bs.modal', (e) => { return opts.closed(e) })

        this.main = new Modal(m, opts.config??{})


    }

    show(){

        this.main.show()
    }
    hide(){

        this.main.hide()
    }

    static get btn(){
        return [ $('<button>')
                .addClass('btn-close')
                .attr('aria-label', 'Close')
                .attr('type', 'button')
                .attr('data-bs-dismiss', 'modal')
        ]
    }

}

/*
<div class="modal fade" tabindex="-1" id="CSModal">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Modal title</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body"></div>
            <div class="modal-footer">
{{--                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>--}}
{{--                <button type="button" class="btn btn-primary">Save changes</button>--}}
            </div>
        </div>
    </div>
</div>

 */
